// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { AdminProjectSummary, AdminWorkspaceDetail, AdminWorkspaceList, AdminWorkspaceSummary, SupportGrantResponse } from "../admin/dto.generated";
import type { CreditBalance, CreditBucket, ListRatesResponse, RateInfo } from "../credits/dto.generated";
import type { Enforcement, Kind, LimitKey, LimitKeyInfo, ListTiersResponse, TierInfo } from "../tiers/dto.generated";
import type { ListUsersResponse, UserPreferencesResponse, UserResponse } from "../user/dto.generated";
import type { AddMemberResponse, ListWorkspaceMembersResponse, PendingWorkspaceInvitationResponse, ReportSettingsResponse, UpdateMemberRoleResponse, WorkspaceMemberResponse, WorkspaceResponse } from "../workspace/dto.generated";
export const addTagTypes = [
  "credits",
  "projects",
  "admin",
  "tiers",
  "users",
  "workspaces",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiAdminCreditRates: build.query<
        GetApiAdminCreditRatesApiResponse,
        GetApiAdminCreditRatesApiArg
      >({
        query: () => ({ url: `/api/admin/credit-rates` }),
        providesTags: ["credits"],
      }),
      postApiAdminCreditRates: build.mutation<
        PostApiAdminCreditRatesApiResponse,
        PostApiAdminCreditRatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/credit-rates`,
          method: "POST",
          body: queryArg.creditsCreateRateRequest,
        }),
        invalidatesTags: ["credits"],
      }),
      getApiAdminProjectsByProjectIdMembers: build.query<
        GetApiAdminProjectsByProjectIdMembersApiResponse,
        GetApiAdminProjectsByProjectIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/members`,
        }),
        providesTags: ["projects"],
      }),
      postApiAdminProjectsByProjectIdMembers: build.mutation<
        PostApiAdminProjectsByProjectIdMembersApiResponse,
        PostApiAdminProjectsByProjectIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/members`,
          method: "POST",
          body: queryArg.workspaceAddMemberRequest,
        }),
        invalidatesTags: ["projects"],
      }),
      getApiAdminProjectsByProjectIdMembersInvitations: build.query<
        GetApiAdminProjectsByProjectIdMembersInvitationsApiResponse,
        GetApiAdminProjectsByProjectIdMembersInvitationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/members/invitations`,
        }),
        providesTags: ["projects"],
      }),
      deleteApiAdminProjectsByProjectIdMembersInvitationsAndInvitationId:
        build.mutation<
          DeleteApiAdminProjectsByProjectIdMembersInvitationsAndInvitationIdApiResponse,
          DeleteApiAdminProjectsByProjectIdMembersInvitationsAndInvitationIdApiArg
        >({
          query: (queryArg) => ({
            url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/members/invitations/${encodeURIComponent(String(queryArg.invitationId))}`,
            method: "DELETE",
          }),
          invalidatesTags: ["projects"],
        }),
      deleteApiAdminProjectsByProjectIdMembersAndUserId: build.mutation<
        DeleteApiAdminProjectsByProjectIdMembersAndUserIdApiResponse,
        DeleteApiAdminProjectsByProjectIdMembersAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/members/${encodeURIComponent(String(queryArg.userId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["projects"],
      }),
      patchApiAdminProjectsByProjectIdMembersAndUserIdRole: build.mutation<
        PatchApiAdminProjectsByProjectIdMembersAndUserIdRoleApiResponse,
        PatchApiAdminProjectsByProjectIdMembersAndUserIdRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/members/${encodeURIComponent(String(queryArg.userId))}/role`,
          method: "PATCH",
          body: queryArg.workspaceUpdateWorkspaceMemberRoleRequest,
        }),
        invalidatesTags: ["projects"],
      }),
      postApiAdminProjectsByProjectIdSupportAccess: build.mutation<
        PostApiAdminProjectsByProjectIdSupportAccessApiResponse,
        PostApiAdminProjectsByProjectIdSupportAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/support-access`,
          method: "POST",
          body: queryArg.supportgrantSupportGrantRequest,
        }),
        invalidatesTags: ["admin"],
      }),
      deleteApiAdminProjectsByProjectIdSupportAccessAndUserId: build.mutation<
        DeleteApiAdminProjectsByProjectIdSupportAccessAndUserIdApiResponse,
        DeleteApiAdminProjectsByProjectIdSupportAccessAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/projects/${encodeURIComponent(String(queryArg.projectId))}/support-access/${encodeURIComponent(String(queryArg.userId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["admin"],
      }),
      getApiAdminSupportAccess: build.query<
        GetApiAdminSupportAccessApiResponse,
        GetApiAdminSupportAccessApiArg
      >({
        query: () => ({ url: `/api/admin/support-access` }),
        providesTags: ["admin"],
      }),
      getApiAdminTiers: build.query<
        GetApiAdminTiersApiResponse,
        GetApiAdminTiersApiArg
      >({
        query: () => ({ url: `/api/admin/tiers` }),
        providesTags: ["tiers"],
      }),
      postApiAdminTiers: build.mutation<
        PostApiAdminTiersApiResponse,
        PostApiAdminTiersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/tiers`,
          method: "POST",
          body: queryArg.tiersCreateTierRequest,
        }),
        invalidatesTags: ["tiers"],
      }),
      deleteApiAdminTiersByName: build.mutation<
        DeleteApiAdminTiersByNameApiResponse,
        DeleteApiAdminTiersByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/tiers/${encodeURIComponent(String(queryArg.name))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["tiers"],
      }),
      patchApiAdminTiersByName: build.mutation<
        PatchApiAdminTiersByNameApiResponse,
        PatchApiAdminTiersByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/tiers/${encodeURIComponent(String(queryArg.name))}`,
          method: "PATCH",
          body: queryArg.tiersUpdateTierRequest,
        }),
        invalidatesTags: ["tiers"],
      }),
      getApiAdminUsers: build.query<
        GetApiAdminUsersApiResponse,
        GetApiAdminUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users`,
          params: {
            email: queryArg.email,
            username: queryArg.username,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["users"],
      }),
      getApiAdminUsersById: build.query<
        GetApiAdminUsersByIdApiResponse,
        GetApiAdminUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users/${encodeURIComponent(String(queryArg.id))}`,
        }),
        providesTags: ["users"],
      }),
      deleteApiAdminUsersById: build.mutation<
        DeleteApiAdminUsersByIdApiResponse,
        DeleteApiAdminUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/users/${encodeURIComponent(String(queryArg.id))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["users"],
      }),
      getApiAdminWorkspaces: build.query<
        GetApiAdminWorkspacesApiResponse,
        GetApiAdminWorkspacesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces`,
          params: {
            q: queryArg.q,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["admin"],
      }),
      postApiAdminWorkspaces: build.mutation<
        PostApiAdminWorkspacesApiResponse,
        PostApiAdminWorkspacesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces`,
          method: "POST",
          body: queryArg.workspaceCreateWorkspaceRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiAdminWorkspacesById: build.query<
        GetApiAdminWorkspacesByIdApiResponse,
        GetApiAdminWorkspacesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}`,
        }),
        providesTags: ["admin"],
      }),
      getApiAdminWorkspacesByIdCredits: build.query<
        GetApiAdminWorkspacesByIdCreditsApiResponse,
        GetApiAdminWorkspacesByIdCreditsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/credits`,
        }),
        providesTags: ["credits"],
      }),
      postApiAdminWorkspacesByIdCreditsGrants: build.mutation<
        PostApiAdminWorkspacesByIdCreditsGrantsApiResponse,
        PostApiAdminWorkspacesByIdCreditsGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/credits/grants`,
          method: "POST",
          body: queryArg.creditsGrantCreditsRequest,
        }),
        invalidatesTags: ["credits"],
      }),
      getApiAdminWorkspacesByIdInvitations: build.query<
        GetApiAdminWorkspacesByIdInvitationsApiResponse,
        GetApiAdminWorkspacesByIdInvitationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/invitations`,
        }),
        providesTags: ["workspaces"],
      }),
      deleteApiAdminWorkspacesByIdInvitationsAndInvitationId: build.mutation<
        DeleteApiAdminWorkspacesByIdInvitationsAndInvitationIdApiResponse,
        DeleteApiAdminWorkspacesByIdInvitationsAndInvitationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/invitations/${encodeURIComponent(String(queryArg.invitationId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["workspaces"],
      }),
      getApiAdminWorkspacesByIdMembers: build.query<
        GetApiAdminWorkspacesByIdMembersApiResponse,
        GetApiAdminWorkspacesByIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/members`,
          params: {
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["workspaces"],
      }),
      postApiAdminWorkspacesByIdMembers: build.mutation<
        PostApiAdminWorkspacesByIdMembersApiResponse,
        PostApiAdminWorkspacesByIdMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/members`,
          method: "POST",
          body: queryArg.workspaceAddMemberRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      deleteApiAdminWorkspacesByIdMembersAndUserId: build.mutation<
        DeleteApiAdminWorkspacesByIdMembersAndUserIdApiResponse,
        DeleteApiAdminWorkspacesByIdMembersAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/members/${encodeURIComponent(String(queryArg.userId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["workspaces"],
      }),
      patchApiAdminWorkspacesByIdMembersAndUserIdRole: build.mutation<
        PatchApiAdminWorkspacesByIdMembersAndUserIdRoleApiResponse,
        PatchApiAdminWorkspacesByIdMembersAndUserIdRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/members/${encodeURIComponent(String(queryArg.userId))}/role`,
          method: "PATCH",
          body: queryArg.workspaceUpdateWorkspaceMemberRoleRequest,
        }),
        invalidatesTags: ["workspaces"],
      }),
      patchApiAdminWorkspacesByIdPlan: build.mutation<
        PatchApiAdminWorkspacesByIdPlanApiResponse,
        PatchApiAdminWorkspacesByIdPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/plan`,
          method: "PATCH",
          body: queryArg.adminAdminUpdatePlanRequest,
        }),
        invalidatesTags: ["admin"],
      }),
      getApiAdminWorkspacesByIdSupportAccess: build.query<
        GetApiAdminWorkspacesByIdSupportAccessApiResponse,
        GetApiAdminWorkspacesByIdSupportAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/support-access`,
        }),
        providesTags: ["admin"],
      }),
      postApiAdminWorkspacesByIdSupportAccess: build.mutation<
        PostApiAdminWorkspacesByIdSupportAccessApiResponse,
        PostApiAdminWorkspacesByIdSupportAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/support-access`,
          method: "POST",
          body: queryArg.supportgrantSupportGrantRequest,
        }),
        invalidatesTags: ["admin"],
      }),
      deleteApiAdminWorkspacesByIdSupportAccessAndUserId: build.mutation<
        DeleteApiAdminWorkspacesByIdSupportAccessAndUserIdApiResponse,
        DeleteApiAdminWorkspacesByIdSupportAccessAndUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/workspaces/${encodeURIComponent(String(queryArg.id))}/support-access/${encodeURIComponent(String(queryArg.userId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["admin"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as adminApi };
export type GetApiAdminCreditRatesApiResponse =
  /** status 200 OK */ { data: CreditsListRatesResponse };
export type GetApiAdminCreditRatesApiArg = void;
export type PostApiAdminCreditRatesApiResponse =
  /** status 201 Created */ { data: CreditsRateInfo };
export type PostApiAdminCreditRatesApiArg = {
  /** Rate row */
  creditsCreateRateRequest: CreditsCreateRateRequest;
};
export type GetApiAdminProjectsByProjectIdMembersApiResponse =
  /** status 200 OK */ { data: WorkspaceListWorkspaceMembersResponse };
export type GetApiAdminProjectsByProjectIdMembersApiArg = {
  /** Project ID */
  projectId: string;
};
export type PostApiAdminProjectsByProjectIdMembersApiResponse =
  /** status 201 Created */ { data: WorkspaceAddMemberResponse };
export type PostApiAdminProjectsByProjectIdMembersApiArg = {
  /** Project ID */
  projectId: string;
  /** Add member by email request */
  workspaceAddMemberRequest: WorkspaceAddMemberRequest;
};
export type GetApiAdminProjectsByProjectIdMembersInvitationsApiResponse =
  /** status 200 OK */ { data: WorkspacePendingWorkspaceInvitationResponse[] };
export type GetApiAdminProjectsByProjectIdMembersInvitationsApiArg = {
  /** Project ID */
  projectId: string;
};
export type DeleteApiAdminProjectsByProjectIdMembersInvitationsAndInvitationIdApiResponse =
  unknown;
export type DeleteApiAdminProjectsByProjectIdMembersInvitationsAndInvitationIdApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Invitation ID */
    invitationId: string;
  };
export type DeleteApiAdminProjectsByProjectIdMembersAndUserIdApiResponse =
  unknown;
export type DeleteApiAdminProjectsByProjectIdMembersAndUserIdApiArg = {
  /** Project ID */
  projectId: string;
  /** User ID */
  userId: string;
};
export type PatchApiAdminProjectsByProjectIdMembersAndUserIdRoleApiResponse =
  /** status 200 OK */ { data: WorkspaceUpdateMemberRoleResponse };
export type PatchApiAdminProjectsByProjectIdMembersAndUserIdRoleApiArg = {
  /** Project ID */
  projectId: string;
  /** User ID */
  userId: string;
  /** Update member role request */
  workspaceUpdateWorkspaceMemberRoleRequest: WorkspaceUpdateWorkspaceMemberRoleRequest;
};
export type PostApiAdminProjectsByProjectIdSupportAccessApiResponse = unknown;
export type PostApiAdminProjectsByProjectIdSupportAccessApiArg = {
  /** Project ID */
  projectId: string;
  /** Grant */
  supportgrantSupportGrantRequest: SupportgrantSupportGrantRequest;
};
export type DeleteApiAdminProjectsByProjectIdSupportAccessAndUserIdApiResponse =
  unknown;
export type DeleteApiAdminProjectsByProjectIdSupportAccessAndUserIdApiArg = {
  /** Project ID */
  projectId: string;
  /** User ID */
  userId: string;
};
export type GetApiAdminSupportAccessApiResponse =
  /** status 200 OK */ { data: SupportgrantSupportGrantResponse[] };
export type GetApiAdminSupportAccessApiArg = void;
export type GetApiAdminTiersApiResponse = /** status 200 OK */ { data: TiersListTiersResponse };
export type GetApiAdminTiersApiArg = void;
export type PostApiAdminTiersApiResponse =
  /** status 201 Created */ { data: TiersTierInfo };
export type PostApiAdminTiersApiArg = {
  /** Tier creation request */
  tiersCreateTierRequest: TiersCreateTierRequest;
};
export type DeleteApiAdminTiersByNameApiResponse = unknown;
export type DeleteApiAdminTiersByNameApiArg = {
  /** Tier name */
  name: string;
};
export type PatchApiAdminTiersByNameApiResponse =
  /** status 200 OK */ { data: TiersTierInfo };
export type PatchApiAdminTiersByNameApiArg = {
  /** Tier name */
  name: string;
  /** Tier update request */
  tiersUpdateTierRequest: TiersUpdateTierRequest;
};
export type GetApiAdminUsersApiResponse = /** status 200 OK */ { data: UserListUsersResponse };
export type GetApiAdminUsersApiArg = {
  /** Filter by email (partial match) */
  email?: string;
  /** Filter by username/name (partial match) */
  username?: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type GetApiAdminUsersByIdApiResponse =
  /** status 200 OK */ { data: UserUserResponse };
export type GetApiAdminUsersByIdApiArg = {
  /** User ID */
  id: string;
};
export type DeleteApiAdminUsersByIdApiResponse = unknown;
export type DeleteApiAdminUsersByIdApiArg = {
  /** User ID */
  id: string;
};
export type GetApiAdminWorkspacesApiResponse =
  /** status 200 OK */ { data: AdminAdminWorkspaceList };
export type GetApiAdminWorkspacesApiArg = {
  /** Name or member email fragment */
  q?: string;
  /** Page size (max 200, default 50) */
  limit?: number;
  /** Rows to skip */
  offset?: number;
};
export type PostApiAdminWorkspacesApiResponse =
  /** status 201 Created */ { data: WorkspaceWorkspaceResponse };
export type PostApiAdminWorkspacesApiArg = {
  /** Workspace creation request */
  workspaceCreateWorkspaceRequest: WorkspaceCreateWorkspaceRequest;
};
export type GetApiAdminWorkspacesByIdApiResponse =
  /** status 200 OK */ { data: AdminAdminWorkspaceDetail };
export type GetApiAdminWorkspacesByIdApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiAdminWorkspacesByIdCreditsApiResponse =
  /** status 200 OK */ { data: CreditsCreditBalance };
export type GetApiAdminWorkspacesByIdCreditsApiArg = {
  /** Workspace ID */
  id: string;
};
export type PostApiAdminWorkspacesByIdCreditsGrantsApiResponse =
  /** status 201 Created */ { data: CreditsCreditBalance };
export type PostApiAdminWorkspacesByIdCreditsGrantsApiArg = {
  /** Workspace ID */
  id: string;
  /** Grant request */
  creditsGrantCreditsRequest: CreditsGrantCreditsRequest;
};
export type GetApiAdminWorkspacesByIdInvitationsApiResponse =
  /** status 200 OK */ { data: WorkspacePendingWorkspaceInvitationResponse[] };
export type GetApiAdminWorkspacesByIdInvitationsApiArg = {
  /** Workspace ID */
  id: string;
};
export type DeleteApiAdminWorkspacesByIdInvitationsAndInvitationIdApiResponse =
  unknown;
export type DeleteApiAdminWorkspacesByIdInvitationsAndInvitationIdApiArg = {
  /** Workspace ID */
  id: string;
  /** Invitation ID */
  invitationId: string;
};
export type GetApiAdminWorkspacesByIdMembersApiResponse =
  /** status 200 OK */ { data: WorkspaceListWorkspaceMembersResponse };
export type GetApiAdminWorkspacesByIdMembersApiArg = {
  /** Workspace ID */
  id: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type PostApiAdminWorkspacesByIdMembersApiResponse =
  /** status 201 Created */ WorkspaceAddMemberResponse;
export type PostApiAdminWorkspacesByIdMembersApiArg = {
  /** Workspace ID */
  id: string;
  /** Add member by email request */
  workspaceAddMemberRequest: WorkspaceAddMemberRequest;
};
export type DeleteApiAdminWorkspacesByIdMembersAndUserIdApiResponse = unknown;
export type DeleteApiAdminWorkspacesByIdMembersAndUserIdApiArg = {
  /** Workspace ID */
  id: string;
  /** User ID */
  userId: string;
};
export type PatchApiAdminWorkspacesByIdMembersAndUserIdRoleApiResponse =
  /** status 200 OK */ WorkspaceUpdateMemberRoleResponse;
export type PatchApiAdminWorkspacesByIdMembersAndUserIdRoleApiArg = {
  /** Workspace ID */
  id: string;
  /** User ID */
  userId: string;
  /** Update member role request */
  workspaceUpdateWorkspaceMemberRoleRequest: WorkspaceUpdateWorkspaceMemberRoleRequest;
};
export type PatchApiAdminWorkspacesByIdPlanApiResponse =
  /** status 200 OK */ { data: AdminAdminWorkspaceDetail };
export type PatchApiAdminWorkspacesByIdPlanApiArg = {
  /** Workspace ID */
  id: string;
  /** Plan change */
  adminAdminUpdatePlanRequest: AdminAdminUpdatePlanRequest;
};
export type GetApiAdminWorkspacesByIdSupportAccessApiResponse =
  /** status 200 OK */ { data: SupportgrantSupportGrantResponse[] };
export type GetApiAdminWorkspacesByIdSupportAccessApiArg = {
  /** Workspace ID */
  id: string;
};
export type PostApiAdminWorkspacesByIdSupportAccessApiResponse = unknown;
export type PostApiAdminWorkspacesByIdSupportAccessApiArg = {
  /** Workspace ID */
  id: string;
  /** Grant */
  supportgrantSupportGrantRequest: SupportgrantSupportGrantRequest;
};
export type DeleteApiAdminWorkspacesByIdSupportAccessAndUserIdApiResponse =
  unknown;
export type DeleteApiAdminWorkspacesByIdSupportAccessAndUserIdApiArg = {
  /** Workspace ID */
  id: string;
  /** User ID */
  userId: string;
};
export type CreditsRateInfo = RateInfo;
export type CreditsListRatesResponse = ListRatesResponse;
export type CreditsCreateRateRequest = {
  credits_per_million: number;
  effective_from?: string;
  model_id: string;
  provider: string;
  source: string;
  token_kind: "input" | "output" | "cache_read" | "cache_creation";
};
export type WorkspaceWorkspaceMemberResponse = WorkspaceMemberResponse;
export type WorkspaceListWorkspaceMembersResponse = ListWorkspaceMembersResponse;
export type WorkspaceAddMemberResponse = AddMemberResponse;
export type WorkspaceAddMemberRequest = {
  /** AcceptExtraSeat is an owner's answer to SEAT_NOT_INCLUDED: yes, add this person
    even though the seat is billed. Ignored while the org is within its included seats. */
  accept_extra_seat?: boolean;
  email: string;
  /** Role to assign on invite. Defaults to "member" when empty. */
  role?: "owner" | "admin" | "member" | "readonly";
};
export type WorkspacePendingWorkspaceInvitationResponse = PendingWorkspaceInvitationResponse;
export type WorkspaceUpdateMemberRoleResponse = UpdateMemberRoleResponse;
export type WorkspaceUpdateWorkspaceMemberRoleRequest = {
  role: "owner" | "admin" | "member" | "readonly";
};
export type SupportgrantSupportGrantRequest = {
  duration: "24h" | "7d" | "30d";
  email: string;
  reason: string;
};
export type SupportgrantSupportGrantResponse = SupportGrantResponse;
export type TiersPlanLimits = {
  agent_monthly_credits?: number;
  alert_checks_per_day?: number;
  alert_rules?: number;
  custom_refresh_cadence?: boolean;
  dashboards?: number;
  gold_tables?: number;
  incremental_refresh?: boolean;
  premium_connectors?: boolean;
  processing_gb_per_month?: number;
  refresh_runs_per_day?: number;
  seats?: number;
  seats_included?: number;
  source_tables?: number;
  storage_gb?: number;
  studio_documents?: number;
  workspaces_per_member?: number;
};
export type TiersTierInfo = TierInfo;
export type TiersEnforcement = Enforcement;
export type TiersLimitKey = LimitKey;
export type TiersKind = Kind;
export type TiersLimitKeyInfo = LimitKeyInfo;
export type TiersListTiersResponse = ListTiersResponse;
export type TiersCreateTierRequest = {
  display_name: string;
  gold_table_limit?: number;
  limits?: TiersPlanLimits;
  max_users?: number;
  monthly_credits?: number;
  name: string;
};
export type TiersUpdateTierRequest = {
  display_name?: string;
  limits?: TiersPlanLimits;
};
export type UserUserPreferencesResponse = UserPreferencesResponse;
export type UserUserResponse = UserResponse;
export type UserListUsersResponse = ListUsersResponse;
export type AdminAdminWorkspaceSummary = AdminWorkspaceSummary;
export type AdminAdminWorkspaceList = AdminWorkspaceList;
export type WorkspaceReportSettingsResponse = ReportSettingsResponse;
export type WorkspaceWorkspaceResponse = WorkspaceResponse;
export type WorkspaceCreateWorkspaceRequest = {
  index_color?: number;
  name: string;
  owner_user_id?: string;
  subscription_tier: string;
};
export type AdminAdminProjectSummary = AdminProjectSummary;
export type AdminAdminWorkspaceDetail = AdminWorkspaceDetail;
export type CreditsCreditBucket = CreditBucket;
export type CreditsCreditBalance = CreditBalance;
export type CreditsGrantCreditsRequest = {
  amount: number;
  expires_at?: string;
  idempotency_key: string;
  note?: string;
  reference?: string;
  source: "plan" | "purchase" | "trial" | "support";
};
export type AdminAdminUpdatePlanRequest = {
  subscription_tier?: string;
  trial_ends_at?: string;
};
export const {
  useGetApiAdminCreditRatesQuery,
  useLazyGetApiAdminCreditRatesQuery,
  usePostApiAdminCreditRatesMutation,
  useGetApiAdminProjectsByProjectIdMembersQuery,
  useLazyGetApiAdminProjectsByProjectIdMembersQuery,
  usePostApiAdminProjectsByProjectIdMembersMutation,
  useGetApiAdminProjectsByProjectIdMembersInvitationsQuery,
  useLazyGetApiAdminProjectsByProjectIdMembersInvitationsQuery,
  useDeleteApiAdminProjectsByProjectIdMembersInvitationsAndInvitationIdMutation,
  useDeleteApiAdminProjectsByProjectIdMembersAndUserIdMutation,
  usePatchApiAdminProjectsByProjectIdMembersAndUserIdRoleMutation,
  usePostApiAdminProjectsByProjectIdSupportAccessMutation,
  useDeleteApiAdminProjectsByProjectIdSupportAccessAndUserIdMutation,
  useGetApiAdminSupportAccessQuery,
  useLazyGetApiAdminSupportAccessQuery,
  useGetApiAdminTiersQuery,
  useLazyGetApiAdminTiersQuery,
  usePostApiAdminTiersMutation,
  useDeleteApiAdminTiersByNameMutation,
  usePatchApiAdminTiersByNameMutation,
  useGetApiAdminUsersQuery,
  useLazyGetApiAdminUsersQuery,
  useGetApiAdminUsersByIdQuery,
  useLazyGetApiAdminUsersByIdQuery,
  useDeleteApiAdminUsersByIdMutation,
  useGetApiAdminWorkspacesQuery,
  useLazyGetApiAdminWorkspacesQuery,
  usePostApiAdminWorkspacesMutation,
  useGetApiAdminWorkspacesByIdQuery,
  useLazyGetApiAdminWorkspacesByIdQuery,
  useGetApiAdminWorkspacesByIdCreditsQuery,
  useLazyGetApiAdminWorkspacesByIdCreditsQuery,
  usePostApiAdminWorkspacesByIdCreditsGrantsMutation,
  useGetApiAdminWorkspacesByIdInvitationsQuery,
  useLazyGetApiAdminWorkspacesByIdInvitationsQuery,
  useDeleteApiAdminWorkspacesByIdInvitationsAndInvitationIdMutation,
  useGetApiAdminWorkspacesByIdMembersQuery,
  useLazyGetApiAdminWorkspacesByIdMembersQuery,
  usePostApiAdminWorkspacesByIdMembersMutation,
  useDeleteApiAdminWorkspacesByIdMembersAndUserIdMutation,
  usePatchApiAdminWorkspacesByIdMembersAndUserIdRoleMutation,
  usePatchApiAdminWorkspacesByIdPlanMutation,
  useGetApiAdminWorkspacesByIdSupportAccessQuery,
  useLazyGetApiAdminWorkspacesByIdSupportAccessQuery,
  usePostApiAdminWorkspacesByIdSupportAccessMutation,
  useDeleteApiAdminWorkspacesByIdSupportAccessAndUserIdMutation,
} = injectedRtkApi;
